import { takeLatest, put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import * as api from 'data/api';
import * as statelessActions from './actions';
import { transformPaymentsIdentityConfiguration } from './transformers';
import { actions } from './slice';
import * as selectors from './selectors';
export function* fetchConfiguraton() {
  const response = yield* call(api.getPaymentsIdentityFormConfiguration);

  if ('errors' in response) {
    yield put(statelessActions.fetchFormConfigurationFailure());
    return;
  }

  const configuration = transformPaymentsIdentityConfiguration(response);
  yield put(actions.setConfiguration({
    configuration
  }));
}
export function* submitForm() {
  yield put(actions.setIsFormDisabled({
    isFormDisabled: true
  }));
  yield put(actions.setHasUnknownApiErrorOccured({
    status: false
  }));
  const formData = yield* select(selectors.getFormData);
  const response = yield* call(api.submitPaymentsIdentity, formData);

  if ('errors' in response) {
    yield put(actions.setGeneralErrors({
      errors: response.errors
    }));
    yield put(actions.setIsFormDisabled({
      isFormDisabled: false
    }));
    if (!response.errors.length) yield put(actions.setHasUnknownApiErrorOccured({
      status: true
    }));
    return;
  }

  const configuration = transformPaymentsIdentityConfiguration(response);
  yield put(actions.setConfiguration({
    configuration
  }));
  yield put(actions.submitFormSuccess());
}
export default function* saga() {
  yield takeLatest(statelessActions.fetchFormConfigurationRequest, fetchConfiguraton);
  yield takeLatest(actions.submitFormRequest, submitForm);
}